// src/components/Finanzas/utils/paymentColors.js
// Display metadata for invoice_payments.payment_method.
//
// Keys are exactly the six values allowed by the database CHECK constraint —
// do not add others. Order is by live volume. us_bank and wise have no movement
// yet but stay listed so the legend covers the full set instead of shifting the
// day one of them first appears.

export const PAYMENT_METHOD_META = {
  banco_agricola: { label: 'Banco Agrícola', color: '#0EA5E9' },
  cash:           { label: 'Efectivo',       color: '#10B981' },
  zelle:          { label: 'Zelle',          color: '#7C3AED' },
  us_bank:        { label: 'US Bank',        color: '#3B82F6' },
  wise:           { label: 'Wise',           color: '#F59E0B' },
  other:          { label: 'Otros',          color: '#94A3B8' },
};

export const PAYMENT_METHOD_ORDER = ['banco_agricola', 'cash', 'zelle', 'us_bank', 'wise', 'other'];
